import { io } from "socket.io-client";
import {SOCKET_URL} from "@/globals/contants";
import {getToken} from "@/services/authService";

const socket = io(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true, // Permite enviar cookies
    query: {
        token: getToken(), // Adjunta el token como parte de la consulta
    },
});

export default socket;
